class FileStorage {
  constructor(serverUrl = process.env.REACT_APP_API_BASE || '') {
    this.serverUrl = serverUrl;
  }

  async getPresetData(preset) {
    try {
      const response = await fetch(
        `${this.serverUrl}/api/client-data-preset/${preset}`
      );
      if (response.ok) {
        const result = await response.json();
        return result.data;
      }
    } catch (error) {
      console.error(`Error reading ${preset}:`, error);
    }
    return null;
  }

  async get(key) {
    try {
      const response = await fetch(`${this.serverUrl}/api/client-data/${key}`);
      if (response.ok) {
        const result = await response.json();
        return result.data;
      }
    } catch (error) {
      console.error(`Error reading ${key}:`, error);
    }
    return null;
  }

  async set(key, data) {
    try {
      const response = await fetch(`${this.serverUrl}/api/client-data/${key}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ data }),
      });
      return response.ok;
    } catch (error) {
      console.error(`Error writing ${key}:`, error);
      return false;
    }
  }

  async remove(key) {
    try {
      const response = await fetch(`${this.serverUrl}/api/client-data/${key}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ data: null }),
      });
      return response.ok;
    } catch (error) {
      console.error(`Error removing ${key}:`, error);
      return false;
    }
  }
}

export const fileStorage = new FileStorage();
